import {
  FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS,
} from './actions';
import CoreAndCatchUp from './model';
import { List, Map } from 'immutable';

export default function CoreAndCatchUpReducer(state = new Map(), action) {
  switch (action.type) {
    case FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS:
      return state.set(`${action.groupId}`, onFetchCoreAndCatchUpSuccess(action.payload));
    default:
      return state;
  }
}

function onFetchCoreAndCatchUpSuccess(response) {
  return response.reduce((list, item) => list.push(CoreAndCatchUp.create(item)), new List());
}



// WEBPACK FOOTER //
// ./data/WritingAssignment/CoreAndCatchUp/reducer.js